<template>
    <div v-if="client" class="container bng-casino-cash-start">
        <video class="bng-casino-cash-start-banner" autoplay="autoplay" loop muted="muted" playsinline>
            <source src="/static/cash/casino-cash-start/banner_cashback.webm" type='video/webm'>
            <source src="/static/cash/casino-cash-start/banner_cashback.mp4" type='video/mp4' >
        </video>
        <h3
                    v-if="popularGames && popularGames.length"
                    class="title title-popular is-3 is-spaced has-text-centered"
                >
                    {{"components.pages.casino-home.popular-games" | translate}}
                    <img src="/static/cash/casino-cash-start/popular.svg" alt="popular">
                </h3>
        <div class="bng-casino-cash-start__wrapper">
            <div class="bng-casino-cash-start__games">
                <!-- popular games -->
                <game-list v-if="popularGames && popularGames.length" :games="popularGames" />

                <!-- new games -->
                <h3
                    v-if="newGames && newGames.length"
                    class="title title-new is-3 is-spaced has-text-centered"
                >
                    {{"components.pages.casino-home.new" | translate}}
                    <img src="/static/cash/casino-cash-start/new.svg" alt="new">
                </h3>
                <game-list v-if="newGames && newGames.length" :games="newGames" />
            </div>
            <div v-if="!isMobile" class="bng-casino-cash-start__banners">
                <ul class="bng-casino-cash-start__list">
                    <li class="bng-casino-cash-start__item">
                        <img src="/static/cash/casino-cash-start/banner-bet.jpg" alt="welcome bonus">
                    </li>
                    <li class="bng-casino-cash-start__item" @click ="openGame(game)">
                        <video class="bng-casino-cash-start-video" autoplay="autoplay" loop muted="muted">
                            <source src="/static/cash/casino-cash-start/spintowin_banner.webm" type='video/webm; codecs="vp8, vorbis"'>
                            <source src="/static/cash/casino-cash-start/spintowin_banner.mp4" type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"' >
                        </video>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';

import CasinoHomeBanner from '../../../common/banners/casino-banners/casino-home-banner.vue';
import CasinoHomeCustomBanner from '../../../common/banners/casino-banners/casino-home-custom-banner.vue';
import LastWinnings from '../../../common/last-winnings/last-winnings.vue';
import JackpotsBar from '../../../common/jackpots/jackpots-bar/jackpots-bar.vue';
import GameList from '../../../common/game-list/game-list.vue';
import isMobile from 'ismobilejs';

export default {
    name: 'casino-home',
    data() {
        return {
            game: {
                "provider": "flg",
                "gameId": "248",
                "name": "Spin To Win",
            },
        }
    },
    components: { CasinoHomeBanner, CasinoHomeCustomBanner, LastWinnings, JackpotsBar, GameList },
    computed: {
        client() {
            return Vue.state.client.get();
        },
        isMobile() {
            return isMobile.phone;
        },
        popularGames() {
            return Vue.state.games.get().popular;
        },
        newGames() {
            return Vue.state.games.get().new;
        },
        player() {
            return Vue.state.player.get();
        },
        jackpots() {
            return (
                (this.player &&
                    this.player.balance &&
                    this.player.activeJackpots) ||
                []
            );
        }
    },
    async created() {
        await Vue.state.client.ensure();
    },
    methods: {
        async openGame(game) {
            await Vue.router.teleport.game(game);
        }
    }
};
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/casino-home/casino-cash-start.vue